import type { FaireProductEntity } from "../../entity_types/product";

export const p_hndykg5wzu: FaireProductEntity = {
  token: "p_hndykg5wzu",
  type: "product",
  name: "Soul Eater, Vol. 6",
  brandToken: "b_bomzcs63",
  brandName: "Hachette Book Group",
  imageUrl: "https://cdn.faire.com/fastly/48005612ae3aa0ff16041980d25ce62fc6fb1107cf39afac2474c1dafec03235.jpeg",
  galleryImageUrls: [],
  priceDollars: 6.5,
  description: "Death the Kid and Black*Star race after Free and Eruka, ready to do whatever it takes to stop the Black Blood before it is used to revive the slumbering First Kishin. Meanwhile, Maka has allowed herself to slip into madness in an effort to reach Crona's troubled soul. In addition to being horribly embarrassing, her actions carry a great risk. If Maka can't find Crona fast, she too will be consumed by madness!",
  tags: [],
  msrpDollars: 13,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-10-28T21:06:31.148Z",
    importedBy: "entity-db-cli"
  },
  categoryTokens: []
};
